// @ts-nocheck
import * as React from 'react';
// Sidebar — 80px left rail with logo, nav items, and bottom actions.

import { useNavigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import SmLogo from '../common/SmLogo';
import Icon from '../common/Icon';
import { PILLARS } from '../../data/pillars';

const INTERNAL_NAV_IDS = new Set(["inspire", "childcare", "progress", "language", "feedback", "helpdesk"]);

function SettingsIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 0 1-4 0v-.1A1.7 1.7 0 0 0 9 19.4a1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 0 1 0-4h.1A1.7 1.7 0 0 0 4.6 9a1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 0 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 0 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
    </svg>
  );
}

function RailItem({
  icon,
  label,
  active,
  accentVar,
  onClick,
  disabled,
}: {
  id?: string;
  icon: ReactNode;
  label: string;
  active?: boolean;
  accentVar?: string;
  onClick?: () => void | Promise<void>;
  disabled?: boolean;
}) {
  return (
    <a
      className={"rail-item " + (active ? "is-active " : "") + (disabled ? "is-disabled" : "")}
      onClick={(e) => {
        e.preventDefault();
        if (disabled) return;
        if (onClick) onClick();
      }}
      href="#"
      aria-disabled={disabled ? "true" : undefined}
      tabIndex={disabled ? -1 : undefined}
      style={active && accentVar ? { color: `var(${accentVar})` } : undefined}
    >
      <span className="rail-item__icon">{icon}</span>
      <span className="rail-item__label">{label}</span>
    </a>
  );
}

export default function Sidebar({
  activeId,
  onSelect,
  locked = false,
  showBottom = true,
}: {
  activeId?: string;
  onSelect?: (id: string) => void;
  locked?: boolean;
  showBottom?: boolean;
}) {
  const navigate = useNavigate();

  return (
    <aside className="rail">
      <a className="rail__logo" onClick={() => navigate('/admissions')} title="SooMuch.AI · Home" href="#">
        <SmLogo />
      </a>
      <div className="rail__divider" />
      <nav style={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <RailItem
          id="home"
          icon={<Icon name="command" size={20} />}
          label="Home"
          active={activeId === "home"}
          onClick={() => navigate('/admissions')}
        />
        {PILLARS.map((p) => (
          <RailItem
            key={p.id}
            id={p.id}
            icon={<Icon name={p.icon} size={20} />}
            label={p.sidebarLabel}
            accentVar={p.colorVar}
            active={activeId === p.id}
            disabled={locked || p.id === "survey"}
            onClick={() => {
              if (locked || p.id === "survey") return;
              if (INTERNAL_NAV_IDS.has(p.id)) {
                navigate(`/admissions/internal/${p.id}`);
                return;
              }
              if (onSelect) {
                onSelect(p.id);
                return;
              }
              navigate('/admissions');
            }}
          />
        ))}
      </nav>
      {locked && <div className="rail__lock">SIGN IN TO UNLOCK</div>}
      {showBottom && (
      <div className="rail__bottom">
        <div className="rail__divider" />
        <RailItem id="analytics" icon={<Icon name="analytics" size={20} />} label="Analytics" onClick={() => {}} />
        <RailItem id="settings" icon={<SettingsIcon />} label="Settings" onClick={() => {}} />
      </div>
      )}
    </aside>
  );
}
